export default {
  freeShippingTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-summary-free_shipping_title',
    defaultMessage: 'Free shipping option',
  },
  freeShippingDescription: {
    id: 'bo_seller-options-shipping-rule_drawer-summary-free_shipping_description',
    defaultMessage:
      'Take the weekend off: All deadlines include business days only.',
  },
  paidShippingTitle: {
    id: 'bo_seller-options-shipping-rule_drawer-summary-paid_shipping_title',
    defaultMessage: 'Paid shipping option',
  },
  paidShippingDescription: {
    id: 'bo_seller-options-shipping-rule_drawer-summary-paid_shipping_description',
    defaultMessage:
      'Take the weekend off: All deadlines include business days only.',
  },

  collectionPointTitle: {
    id: 'bo_seller.options.shipping.rule_drawer.summary.collection_point_title',
    defaultMessage: 'Collection point',
  },
  collectionPointDescription: {
    id: 'bo_seller.options.shipping.rule_drawer.summary.collection_point_description',
    defaultMessage:
      'Give your customers the option to pick up orders from collection points.',
  },
} as const
